module.exports = __webpack_public_path__ + "img/Skirt-Front-B2-Db-Fb-Gd-Hc-Ia.20a8ebea.png";